(ns common.widgets.iframe.db
  "The re-frame events can be considered deprecated. The new iframe
  component doesn't need those."
  (:require [common.db.effects.dom]
            [re-frame.core :as rf]))

(defn- ids->iframes
  [id->per-iframe-data ids]
  (->> ids
       (keep (fn [id]
               ;; `get` is needed, it works even when id->per-iframe-data is nil
               (:iframe (get id->per-iframe-data id))))))

;; This could be useful fn, maybe move somewhere else?
(defn dimensions->template-ids
  [{:keys [width height]} templates]
  (->> templates
       (filter #(and (= width (:width %))
                     (= height (:height %))))
       (map :id)))

(rf/reg-fx :iframe/post-message
  (fn [{:keys [iframes message]}]
    (doseq [^js iframe iframes]
      (.postMessage (.-contentWindow iframe) message "*"))))

(rf/reg-fx :iframe/reload-iframes
  (fn [iframes]
    (doseq [^js iframe iframes]
      (set! (.-src iframe)
            (.-src iframe)))))

(rf/reg-event-fx :iframe/register
  (fn [{:keys [db]} [_ {:keys [id ^js ref on-ready]}]]
    (let [event-registration-data {:iframe ref
                                   :target js/window
                                   :event-name "message"
                                   :listener (fn listener [^js e]
                                               (when (and (identical? (.-contentWindow ref) (.-source e))
                                                          (= (.. e -data -type) "lemonpi-awaiting-config"))
                                                 (on-ready id)
                                                 ;; uncomment the line below if `on-ready` should be called only once.
                                                 #_(.removeEventListener js/window "message" listener)))}]
      {:db (assoc-in db [:iframes id] event-registration-data)
       :fx [[:dom/add-event-listener event-registration-data]]})))

(rf/reg-event-fx :iframe/unregister
  (fn [{:keys [db]} [_ id]]
    (let [event-registration-data (get-in db [:iframes id])]
      {:db (update db :iframes dissoc id)
       :fx [[:dom/remove-event-listener event-registration-data]]})))

(rf/reg-event-fx :iframe/post-content-object
  (fn [{:keys [db]} [_ {:keys [ids content-object]}]]
    (let [iframes (ids->iframes (:iframes db) ids)]
      {:iframe/post-message {:iframes iframes
                             :message (clj->js {:type "lemonpi-config"
                                                :config {:exportContent content-object}})}})))

(rf/reg-event-fx :iframe/reload
  (fn [{:keys [db]} [_ ids]]
    {:iframe/reload-iframes (ids->iframes (:iframes db) ids)}))
